import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [
   
  ],
  exports: [

  ],
  imports: [
    CommonModule,
    RouterModule,
  ]
})
export class CoreModule {
}
